import "./WeatherStat.css";

import React from "react";

const WeatherStat = ({ label, icon, value }) => {
  return (
    <div className="weather-stat">
      <h3>{label}</h3>
      <br />
      <div className="parent">
        <img className="child" src={icon} alt="" />
        <div className="child">{value}</div>
      </div>
    </div>
  );
};

export default WeatherStat;
